import React from "react";
import Auth from "../auth/Auth";
import Link from '../base/Link';
import API from "../base/API";
import Storage from "../base/Storage";
import SorTable from '../base/SorTable';
import DeleteButton from "../base/DeleteButton";
import EditButton from "../base/EditButton";
import { translate } from "../base/Translation";

export default class StatisticList extends Auth {
    constructor(props) {
        super(props);

        this.api = new API({
            get_statistics: "/statistic/fetch/all?limit_from=:from&limit_max=:to",
            delete_statistic: "/statistic/delete/:statistic",
        });

        this.state = {
            statistics: [],
            tableData: [],
            tableColumns: [
                { name: "name", display: translate("Názov"), sort: true, width: 47 },
                { name: "weave", display: translate("Vlna"), sort: true, width: 25 },
                { name: "user", display: translate("Používateľ"), sort: true, width: 22 },
                { name: "options", display: " ", width: 5 }
            ]
        };
    }

    convertDataForTable(data) {
        return data.map(function (statistic) {
            let data = {};
            data.name = <Link to={"/statistics/view/" + statistic.id} textIfNoAccess={true} permission="StatisticView">{statistic.name}</Link>
            data.weave = statistic.type === "weave" ? statistic.weave !== false ? statistic.weave.name : "---" : statistic.weave_group !== false ? statistic.weave_group.name : "---";
            data.user = statistic.user !== false ? statistic.user.name : "---";
            data.options = (
                <div>
                    <EditButton to={"/statistics/edit/" + statistic.id} className="btn btn-xs btn-primary" permission="StatisticEdit" />
                    <DeleteButton onClick={this.deleteStatistic.bind({ statistic: statistic.id, currentComponent: this })} className="btn btn-xs btn-danger" permission="StatisticNew" />
                </div>
            )
            return data;
        }.bind(this));
    }

    fetchData() {
        this.api.request({
            cache: true,
            route: "get_statistics",
            params: { from: 0, to: 99999 },
            success: (response) => {
                let tableData = this.convertDataForTable(response);
                this.setState({ statistics: response, tableData });
            }
        });
    }

    componentDidMount() {
        this.fetchData();
    }

    deleteStatistic(evt) {
        this.currentComponent.api.request({
            route: "delete_statistic",
            params: { "statistic": this.statistic },
            success: (response) => {
                this.currentComponent.fetchData();
            }
        });
    }

    render() {
        return (
            <SorTable columns={this.state.tableColumns} data={this.state.tableData} headers={true} searchBy="name" title={translate("Štatistiky")} right={() => {
                if (Storage.get("allowed_components").indexOf("StatisticNew") === -1) {
                    return "";
                }
                return (
                    <Link to="/statistics/add/new" className="btn btn-success btn-sm pull-right"><i className="fa fa-plus" /> {translate("Pridať")}</Link>
                )
            }} />
        );
    }
}


// WEBPACK FOOTER //
// ./src/modules/statistic/StatisticList.jsx